<template>
  <div id="app">
    <component :is="layout" />
  </div>
</template>
<script>
import Layout from "@/layout/Layout.vue";
import NoHeaderLayout from "@/layout/NoHeaderLayout.vue";
import NoHeaderFooterLayout from "@/layout/NoHeaderFooterLayout.vue";

const DEFAULT_LAYOUT = "default";
export default {
  name: "App",
  components: {
    default: Layout,
    "no-header": NoHeaderLayout,
    "no-header-footer": NoHeaderFooterLayout
  },
  data() {
    return {
      email: ""
    };
  },
  computed: {
    layout() {
      return this.$route.meta.layout || DEFAULT_LAYOUT;
    }
  }
};
</script>